module.exports = __webpack_public_path__ + "img/T1A_rc_10.90252808.png";